import { ROUTES } from "../types/routes";

// 需要显示底部导航栏的路由列表
export const BOTTOM_NAV_ROUTES = [
  ROUTES.HOME,
  ROUTES.HOME_ALT,
  ROUTES.VIP,
  ROUTES.EVENT_CENTER,
  ROUTES.PROFILE,
  ROUTES.AGENT_CENTER,
  ROUTES.INVITE_FRIENDS,
] as const;

// 导航栏高度常量
const NAVBAR_HEIGHT = "3rem";
const BOTTOM_NAV_HEIGHT = "3.125rem";
const SHARE_APP_BAR_HEIGHT = "2.75rem";

/**
 * 计算首页顶部偏移量（ShareAppBar + DownloadAppBar）
 * @param shareAppBarVisible ShareAppBar 是否可见
 * @param downloadAppBarVisible DownloadAppBar 是否可见
 * @returns 顶部偏移量
 */
export const getHomePageTopOffset = (
  shareAppBarVisible: boolean,
  downloadAppBarVisible: boolean
): string => {
  if (shareAppBarVisible && downloadAppBarVisible) {
    // 同时显示两个
    return SHARE_APP_BAR_HEIGHT;
  } else if (shareAppBarVisible) {
    return "0rem";
  } else if (downloadAppBarVisible) {
    return SHARE_APP_BAR_HEIGHT;
  } else {
    return "0rem";
  }
};

export const isBottomNavRoute = (location: any): boolean => {
  const hasBottomNav = BOTTOM_NAV_ROUTES.some(route => {
    return location.pathname === route;
  });
  if (!hasBottomNav) {
    return false;
  }
  // 如果是首页，始终显示 Layout
  if (
    location.pathname === ROUTES.HOME ||
    location.pathname === ROUTES.HOME_ALT
  ) {
    return true;
  }

  return location.state?.fromBottomNav === true;
};

export const getPageContentHeight = (
  pathname: string,
  hasNavBar: boolean = true
): string => {
  const hasBottomNav = isBottomNavRoute({ pathname });
  const navBarHeight = hasNavBar ? NAVBAR_HEIGHT : "0rem";
  const bottomNavHeight = hasBottomNav ? BOTTOM_NAV_HEIGHT : "0rem";

  if (!hasNavBar && !hasBottomNav) {
    return "100vh";
  }

  if (hasNavBar && hasBottomNav) {
    return `calc(100vh - ${navBarHeight} - ${bottomNavHeight})`;
  }

  if (hasNavBar) {
    return `calc(100vh - ${navBarHeight})`;
  }

  return `calc(100vh - ${bottomNavHeight})`;
};

/**
 * 更新页面导航栏高度的 CSS 变量
 * @param location 当前路由 location 对象
 * @param homePageTopOffset 首页顶部偏移量（可选，仅首页需要）
 */
export const updatePageLayoutHeight = (
  location: any,
  homePageTopOffset?: string
): void => {
  const root = document.documentElement;

  // 判断是否有底部导航栏
  const hasBottomNav = isBottomNavRoute(location);

  // 判断是否是首页
  const isHomePage =
    location.pathname === ROUTES.HOME || location.pathname === ROUTES.HOME_ALT;

  // 判断是否有顶部导航栏（HomePage 没有顶部导航栏）
  const hasNavBar = !isHomePage;

  // 动态设置 CSS 变量
  root.style.setProperty("--navbar-height", hasNavBar ? NAVBAR_HEIGHT : "0rem");

  root.style.setProperty(
    "--bottom-nav-height",
    hasBottomNav ? BOTTOM_NAV_HEIGHT : "0rem"
  );

  // 如果是首页，设置顶部偏移量
  if (isHomePage && homePageTopOffset !== undefined) {
    root.style.setProperty("--home-top-offset", homePageTopOffset);
  }
};
